export default __webpack_public_path__ + "static/media/Pot1.3b869de8.svg";